import type { Dispatch, SetStateAction } from 'react'
import type { OrderForm } from 'src/sdk/checkout/data/types/orderform'
import type { AddressData } from 'src/sdk/checkout/data/types/orderformAPI'
import type { OrderForm as CheckoutOrderForm } from 'src/sdk/checkout/entity/orderForm'

import type { LocalAddressesPayload } from '../../domain/addressManagerReconciliation'
import { PostalCodeInputForm } from '../Input/PostalCodeInputForm'
import { AddressFormModal } from './AddressFormModal'

interface AddressManagerEditorSectionProps {
  addingAddress: boolean
  newCep: string
  setNewCep: Dispatch<SetStateAction<string>>
  onBack: () => void
  onNewCepSubmit: (value: string) => Promise<void>
  addressFormModalKey: string
  data: Partial<AddressData> | null
  orderForm: OrderForm
  setOrderForm: (orderForm: CheckoutOrderForm) => void
  onUpdateLocalAddresses: (payload: LocalAddressesPayload) => void
}

export function AddressManagerEditorSection({
  addingAddress,
  newCep,
  setNewCep,
  onBack,
  onNewCepSubmit,
  addressFormModalKey,
  data,
  orderForm,
  setOrderForm,
  onUpdateLocalAddresses,
}: AddressManagerEditorSectionProps) {
  return (
    <div className="mt-4 py-5 px-6">
      <button className="mb-4 text-sm text-blue-600" onClick={onBack}>
        ← Voltar para lista
      </button>
      {addingAddress && (
        <div className="mb-4">
          <PostalCodeInputForm
            showLabel
            inputValue={newCep}
            setInputValue={setNewCep}
            onSubmit={onNewCepSubmit}
          />
        </div>
      )}
      <AddressFormModal
        key={addressFormModalKey}
        data={data}
        onSubmit={onBack}
        orderForm={orderForm}
        setOrderForm={setOrderForm}
        onCancel={onBack}
        onUpdateLocalAddresses={onUpdateLocalAddresses}
        submitButtonLabel={
          data ? 'Salvar endereço' : 'Salvar e usar este endereço'
        }
      />
    </div>
  )
}
